<div class="main-content">
    <div class="row">
        <div class="col-12 ">
            <mat-card style="box-shadow: none !important;">
                <mat-card-content style="padding: 15px;">
                    <div class="container mainContentNew">
                        <div>
                            <h2>Wallet</h2>
                        </div>
                        <div class="d-flex justify-content-between d-none d-md-none d-lg-flex">
                            <span class="d-block" style="color: #979797; width: 70%">
                                Manage your certifications and track CEUs with ease
                            </span>
                            <ul class="breadcrumb d-none d-sm-none d-md-none d-lg-flex">
                                <li class="active"><a [routerLink]="['/dashboard/home']">Home</a></li>
                                <li class="separator">/</li>
                                <li><a style="color: #979797" href="#">Wallet</a></li>
                            </ul>
                        </div>

                        <hr style="height: 1px; background: #ccc; border: none" />
                    </div>

                    <div class="container">
                        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #userDtlTabGroup>
                            <mat-tab label="My Certification">

                                <div class="row my-5">
                                    <div class="col-12 col-sm-12 col-md-6">
                                        <h4 class="mt-3">Certification List</h4>
                                        <div style="color: #979797">Manage all your certifications in one place</div>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-6 text-end">
                                        <button (click)="getTranscript()" class="mt-3" style="margin-right: 5px;" mat-raised-button aria-label="request pdf transcript" color="warn">
                                            <mat-icon>picture_as_pdf</mat-icon> Transcript
                                        </button>
                                        <button (click)="checkAbilityToAddMore()" class="mt-3" mat-raised-button aria-label="add certification" style="background:#5B25B4; color: #fff;">
                                            <mat-icon>add</mat-icon> Add Certification
                                        </button>
                                    </div>
                                </div>

                                <my-wallet-certification (getNumberCert)="setNumberCertMax($event)" (refreshCeuCredit)="getRefreshCeuCredit($event)"></my-wallet-certification>

                            </mat-tab>
                            <mat-tab label="CEU">

                                <div class="row my-5">
                                    <div class="col-12 col-sm-12 col-md-6">
                                        <h4 class="mt-3">Continuing Education Units (CEUs)</h4>
                                        <div style="color: #979797">Track and manage your CEUs to advance your professional skills</div>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-6 text-end d-flex justify-content-end">
                                        <button (click)="goAddCeuCredit()" class="mt-3" mat-raised-button aria-label="add certification" style="background:#5B25B4; color: #fff;">
                                            <mat-icon>add</mat-icon> Upload
                                        </button>

                                    </div>
                                </div>

                                <my-wallet-ceu></my-wallet-ceu>

                            </mat-tab>
                            <mat-tab label="Cyber Combine: Scorecard">

                                <div class="row my-5">
                                    <div class="col-12 col-sm-12 col-md-6">
                                        <h4 class="mt-3">Cyber Combine: Scorecard</h4>
                                        <div style="color: #979797">Review your competition scores</div>
                                    </div>
                                </div>

                                <my-assessment></my-assessment>

                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>




